const env = import.meta.env

function toList(value, fallback) {
  return value ? value.split(',').map((item) => item.trim()).filter(Boolean) : fallback
}

export default {
  title: env.VITE_APP_TITLE,
  api: {
    baseURL: env.VITE_API_BASE_URL,
    timeout: Number(env.VITE_API_TIMEOUT),
  },
  wx: {
    appId: env.VITE_WX_APPID,
    // 仅由构建环境决定是否自动跳转网页授权；关闭时页面显示手动 code 登录。
    oauth: {
      enable: env.VITE_WX_OAUTH_ENABLE === 'true',
      scope: env.VITE_WX_OAUTH_SCOPE || 'snsapi_base',
    },
    // JS-SDK 配置供开放标签等能力使用；订阅支付直接调用 WeixinJSBridge。
    debug: env.VITE_WX_DEBUG === 'true',
    jsApiList: toList(env.VITE_WX_JS_API_LIST, ['chooseWXPay']),
    openTagList: toList(env.VITE_WX_OPEN_TAG_LIST, ['wx-open-launch-weapp']),
    miniProgram: {
      username: env.VITE_WX_MINIPROGRAM_USERNAME,
      path: env.VITE_WX_MINIPROGRAM_PATH,
    },
  },
}
